var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrudeOil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#EDFEF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 27.75C15 27.9489 15.079 28.1397 15.2197 28.2803C15.3603 28.421 15.5511 28.5 15.75 28.5H26.25C26.4489 28.5 26.6397 28.421 26.7803 28.2803C26.921 28.1397 27 27.9489 27 27.75V26.25H15V27.75ZM15.285 24.75H26.715L26.25 23.82V18.18L26.715 17.25H15.285L15.75 18.18V23.82L15.285 24.75ZM26.25 13.5H15.75C15.5511 13.5 15.3603 13.579 15.2197 13.7197C15.079 13.8603 15 14.0511 15 14.25V15.75H27V14.25C27 14.0511 26.921 13.8603 26.7803 13.7197C26.6397 13.579 26.4489 13.5 26.25 13.5Z",
    fill: "#00A852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrudeOil);
export default __webpack_public_path__ + "static/media/crude_oil.1be94e4b5b6d87baf726a2ad4aec6517.svg";
export { ForwardRef as ReactComponent };